export default class Component {
	constructor() {
		this.id = 'Component'
	}
	
	init(p5) {

	}

	destroy() {

	}
	
	update(p5, dt) {
		
	}

	handleEvent(e, data) {

	}
}